module.exports = __webpack_public_path__ + "img/edmunddzhang.d867ac43.jpg";